import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner } from "reactstrap";
import moment from "moment";
import ModalImage from "react-modal-image";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { isEmpty } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import { api } from "../../../config";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { resetCompanyState, getCompany } from "../../../store/company/action";
import { resetBranchState, getBranch } from "../../../store/branch/action";
import { resetProductInventoryState, getProductInventory as onGetProductInventories, addNewProductInventory as onAddNewProductInventory, updateProductInventory as onUpdateProductInventory, deleteProductInventory as onDeleteProductInventory, getProductInventoryLoading } from "../../../store/productInventory/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import logoDark from "../../../assets/images/logo-dark.png";
import logoLight from "../../../assets/images/logo-light.png";
import defaultImg from "../../../assets/images/upload.png";
import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import ExportDoc from "../../../Components/Common/ExportDoc";

const StockCard = () => {
  const [pageIdx, setPageIdx] = useState(0);
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, productInventories, isProductInventoryCreated, isProductInventorySuccess, productInventoryAdded, loading, error, companies, branches, branchLoading, companyLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    productInventoryAdded: state.ProductInventory.productInventoryAdded,
    productInventories: state.ProductInventory.productInventories,
    isProductInventoryCreated: state.ProductInventory.isProductInventoryCreated,
    isProductInventorySuccess: state.ProductInventory.isProductInventorySuccess,
    branches: state.Branch.branches,
    branchLoading: state.Branch.loading,
    loading: state.ProductInventory.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    error: state.ProductInventory.error,
  }));

  const [modalDetail, setModalDetail] = useState(false);
  const [logo, setLogo] = useState(defaultImg);
  const [productInventoryList, setProductInventoryList] = useState([]);
  const [productInventoryDoc, setProductInventoryDoc] = useState([]);
  const [productInventory, setProductInventory] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [companyName, setCompanyName] = useState({});
  const [stock, setStock] = useState({});
  const [branchList, setBranchList] = useState([]);

  const [searchBranch, setSearchBranch] = useState("");

  const statusActiveData = [
    {
      options: [
        { label: "ALL", value: "All" },
        { label: "PURCHASE", value: "Purchase" },
        { label: "TRANSFER", value: "Transfer" },
      ],
    },
  ];

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const toggleDetail = useCallback(() => {
    if (modalDetail) {
      setModalDetail(false);
    } else {
      setModalDetail(true);
    }
  }, [modalDetail]);

  const handleStockClick = useCallback(
    (arg, type) => {
      const data = arg;
      let sender = "-";
      let receiver = "-";

      if (data.transaction_type === "Purchase") {
        sender = data.inv_purchase && data?.inv_purchase?.purchase_vendor ? data?.inv_purchase?.purchase_vendor?.name : "-";
        receiver = data.inv_purchase && data.inv_purchase?.purchase_branch ? data.inv_purchase?.purchase_branch?.name : "-";
      } else if (data.transaction_type === "Sales") {
        sender = data.inv_sales && data?.inv_sales?.sales_customer ? data?.inv_sales?.sales_customer?.name : "-";
        receiver = data.inv_sales && data.inv_sales?.sales_branch ? data.inv_sales?.sales_branch?.name : "-";
      } else {
        sender = data.inv_transfer && data?.inv_transfer?.transfer_from ? data?.inv_transfer?.transfer_from?.name : "-";
        receiver = data.inv_transfer && data.inv_transfer.transfer_to ? data.inv_transfer.transfer_to.name : "-";
      }
      setStock({
        details: data.inv_detail ? data.inv_detail : [],
        purchases: data.inv_purchase ? data.inv_purchase.purchase_detail : [],
        sales: data.inv_sales ? data.inv_sales.sales_detail : [],
        transfers: data.inv_transfer ? data.inv_transfer.transfer_detail : [],
        transactionStatus: data.transaction_status,
        transactionType: data.transaction_type,
        inv_file: data.inv_file,
        sender: sender,
        receiver: receiver,
      });

      toggleDetail();
    },
    [toggleDetail, userType]
  );

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (!isEmpty(productInventories)) setProductInventoryList(productInventories.map((el) => ({ ...el, isChecked: false })));
  }, [productInventories]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "code",
        label: "No Transaksi",
        isSelected: true,
        data: [],
      },
      {
        id: "transactionat",
        label: "Tanggal",
        isSelected: true,
        data: [],
      },
      {
        id: "transaction_type_tipe",
        label: "Tipe",
        isSelected: true,
        data: [],
      },
      {
        id: "transaction_status",
        label: "Status",
        isSelected: true,
        data: [],
      },
      {
        id: "inv_branch",
        label: "Cabang Penerima",
        isSelected: true,
        data: [],
      },
      {
        id: "transaction_type_sender",
        label: "Pengirim",
        isSelected: true,
        data: [],
      },
      {
        id: "inv_detail",
        label: "Qty",
        isSelected: true,
        data: [],
      },
      {
        id: "inv_client",
        label: "Grup Usaha",
        isSelected: true,
        data: [],
      },
      {
        id: "inv_company",
        label: "Perusahaan",
        isSelected: true,
        data: [],
      },
    ];

    if (productInventoryList.length > 0) {
      productInventoryList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);

            if (doc) {
              if (doc.id === "transactionat") {
                doc.data.push(handleValidDate(value));
              } else if (doc.id === "inv_branch" || doc.id === "inv_client" || doc.id === "inv_company") {
                doc.data.push(value.name);
              } else if (doc.id === "inv_detail") {
                doc.data.push(data.inv_detail && data.inv_detail.length ? data.inv_detail.length : 0);
              } else {
                doc.data.push(value);
              }
            } else {
              if (key === "transaction_type") {
                const tipeDoc = dataDoc.find((d) => d.id === "transaction_type_tipe");
                const senderDoc = dataDoc.find((d) => d.id === "transaction_type_sender");

                let val = "-";
                switch (value) {
                  case "Purchase":
                    val = data?.inv_purchase?.purchase_vendor && data?.inv_purchase?.purchase_vendor?.name;
                    break;
                  case "Transfer":
                    val = data?.inv_transfer?.transfer_from && data?.inv_transfer?.transfer_from?.name;
                    break;
                  case "Sales":
                    val = data?.inv_sales?.sales_customer && data?.inv_sales?.sales_customer?.name;
                    break;
                  default:
                    val = "-";
                    break;
                }

                tipeDoc.data.push(value);
                senderDoc.data.push(val);
              }
            }
          });
        }
      });
    }

    setProductInventoryDoc(dataDoc);
  }, [productInventoryList]);

  useEffect(() => {
    if (branchSelected) {
      dispatch(resetProductInventoryState());
      dispatch(onGetProductInventories({ type: "inventory", branchId: branchSelected?.value ?? "" }));
    }
  }, [branchSelected]);

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(branches)) {
      var branchData = [];
      var opt = [];
      (branches || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id, companyId: item.companyId };
        opt.push(obj);
      });
      var option = { options: opt };
      branchData.push(option);
      setBranchList(branchData);
    }
  }, [branches]);

  const handleGetBranch = (companyId) => {
    dispatch(resetBranchState());
    dispatch(getBranch({ companyId: companyId, status: 2 }));
  };

  const toggleBranch = (val) => {
    setSearchValue("");
    handleProductInventoryStatus("");
    setFilterDate(null);
    dispatch(onGetProductInventories({ type: "inventory", branchId: val }));
  };

  useEffect(() => {
    setProductInventory(productInventories);
  }, [productInventories]);

  useEffect(() => {
    if (!isEmpty(productInventories)) {
      setProductInventory(productInventories);
    }
  }, [productInventories]);

  useEffect(() => {
    if (!isEmpty(productInventories)) {
      setProductInventoryList(productInventories);
    }
    else {
      setProductInventoryList([]);
    }
  }, [productInventories]);

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = productInventoryList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setProductInventoryList(updated);
    setIsCheckAll(allChecked);
  };

  // Column
  const columns = useMemo(() => [{
    id: "#",
    Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
    filterable: false,
    Cell: (cellProps) => {
      let data = cellProps.row.original;
      return (
        <div className="hstack gap-2 mt-4 mt-sm-0" style={{ width: "60px" }}>
          <input
            type="checkbox"
            className="dataCheckbox me-2 form-check-input"
            checked={data.isChecked}
            onChange={() => {
              const updatedData = productInventoryList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
              setProductInventoryList(updatedData);
            }} />

          <Link
            to="#"
            className="btn-icon btn btn-sm btn-light"
            onClick={() => {
              let data = cellProps.row.original;
              handleStockClick(data, "detail");
              setModalDetail(true);
            }}>
            <i className="ri-eye-line fs-15"></i>
          </Link>
        </div>
      );
    },
  },
  {
    Header: "No Gudang",
    accessor: "code",
    filterable: true,
    Cell: (cellProps) => (
      <Link
        to="#"
        className="fw-semibold"
        onClick={() => {
          let data = cellProps.row.original;
          handleStockClick(data, "detail");
          setModalDetail(true);
        }}
      >
        {cellProps.row.original.code}
      </Link>
    ),
  },

  {
    Header: "Tipe",
    accessor: "transaction_type",
    filterable: true,
    Cell: (cell) => {
      const data = cell.row.original;
      let status = "";
      let type = "";
      switch (data.transaction_status) {
        case "IN":
          status = <span className="badge text-uppercase badge-soft-success">{data.transaction_status}</span>;
          break;
        case "OUT":
          status = <span className="badge text-uppercase badge-soft-danger">{data.transaction_status}</span>;
          break;
        default:
          status = <span className="badge text-uppercase badge-soft-warning">{data.transaction_status}</span>;
          break;
      }

      switch (data.transaction_type) {
        case "Transfer":
          type = <span className="badge text-uppercase badge-soft-success">{cell.value}</span>;
          break;
        case "Purchase":
          type = <span className="badge text-uppercase badge-soft-info">{cell.value}</span>;
          break;
        case "Sales":
          type = <span className="badge text-uppercase badge-soft-secondary">{cell.value}</span>;
          break;
        case "Stok Opname":
          type = <span className="badge text-uppercase badge-soft-primary">{cell.value}</span>;
          break;
        case "Production":
          type = <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
          break;
        default:
          type = "";
          break;
      }

      return (
        <div className="hstack gap-2">
          {type}
          {status}
        </div>
      );
    },
  },
  {
    Header: "No Transaksi",
    accessor: (data) => data.transaction_type === "Purchase" ? data?.inv_purchase?.code : data.transaction_type === "Sales" ? data?.inv_sales?.code : data?.inv_transfer?.code,
    filterable: true,
    Cell: (cellProps) => (
      <Link
        to="#"
        className="fw-semibold"
        onClick={() => {
          let data = cellProps.row.original;
          handleStockClick(data, "detail");
          setModalDetail(true);
        }}
      >
        {cellProps.value}
      </Link>
    ),
  },
  {
    id: "Tgl_Transaksi",
    Header: "Tgl Transaksi",
    accessor: (data) => data.transaction_type === "Purchase" ? data?.inv_purchase?.transactionat : data.transaction_type === "Sales" ? data?.inv_sales?.transactionat : data?.inv_transfer?.transactionat,
    filterable: true,
    Cell: (cell) => {
      return handleValidDate(cell.value);
    },
  },
  {
    id: "Tgl_Gudang",
    Header: "Tgl Gudang",
    accessor: "transactionat",
    filterable: true,
    Cell: (cell) => {
      return handleValidDate(cell.row.original.transactionat);
    },
  },
  {
    id: "Status",
    Header: "Status",
    accessor: "transaction_status",
    filterable: true,
  },
  {
    Header: "Penerima",
    accessor: (data) => (data.transaction_type === "Purchase" ? data?.inv_branch?.name : data.transaction_status === "IN" ? data?.inv_transfer?.transfer_from?.name : data?.inv_transfer?.transfer_to?.name),
    filterable: true,
    Cell: (cell) => {
      const data = cell.cell.row.original;
      switch (cell.row.original.transaction_type) {
        case "Purchase":
          return <span>{data?.inv_branch?.name}</span>;
        case "Transfer":
          return <span>{data.transaction_status === "IN" ? data?.inv_transfer?.transfer_from?.name : data?.inv_transfer?.transfer_to?.name}</span>;
        case "Sales":
          return <span>{data?.inv_sales?.sales_customer && data?.inv_sales?.sales_customer?.name}</span>;
        default:
          return <span>-</span>;
      }
    },
  },
  {
    id: "Detail",
    Header: "Detail",
    accessor: (data) => JSON.stringify(data.inv_detail),
    filterable: true,
  },
  {
    Header: "Pengirim",
    accessor: (data) => (data.transaction_type === "Purchase" ? data?.inv_purchase?.purchase_vendor?.name : data.transaction_status === "OUT" ? data?.inv_transfer?.transfer_from?.name : data?.inv_transfer?.transfer_to?.name),
    filterable: true,
    Cell: (cell) => {
      const data = cell.cell.row.original;
      switch (cell.row.original.transaction_type) {
        case "Purchase":
          return <span>{data?.inv_purchase?.purchase_vendor && data?.inv_purchase?.purchase_vendor?.name}</span>;
        case "Transfer":
          return <span>{data.transaction_status === "OUT" ? data?.inv_transfer?.transfer_from?.name : data?.inv_transfer?.transfer_to?.name}</span>;
        case "Sales":
          return <span>{data?.inv_sales?.sales_customer && data?.inv_sales?.sales_customer?.name}</span>;
        default:
          return <span>-</span>;
      }
    },
  },
  {
    Header: "Qty",
    accessor: "inv_detail",
    filterable: true,
    Cell: (cell) => {
      let qty = 0;
      for (const detail of cell.row.original.inv_detail) qty += parseFloat(detail.quantity);

      return <div className="fw-semibold">{qty}</div>;
    },
  },
  ],
    [productInventoryList, handleStockClick, userType, userRole, isCheckAll]
  );

  const [filterDate, setFilterDate] = useState(null);

  const handleValidDate = (date) => {
    return moment(new Date(date), "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const handleValidTime = (time) => {
    return moment(new Date(time), "YYYY/MM/DD").format("HH:mm");
  };

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = productInventoryList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setProductInventoryList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => productInventoryList, [productInventoryList]);

  //TABLE
  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        hiddenColumns: ["Status", "Detail"],
        pageIndex: pageIdx,
        pageSize: 10,
        selectedRowIds: 0,
        sortBy: [{ id: "Tanggal", desc: true }],
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    setPageIdx(page);
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);

  function handleProductInventoryStatus(data) {
    setStatusActive(data);
  }

  const toggleType = (type) => {
    let filteredProductInventories = productInventories;
    if (type !== "All") {
      filteredProductInventories = productInventories.filter((pInventory) => pInventory.transaction_type === type);
    }
    setProductInventoryList(filteredProductInventories);
  };

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      type: status,
      branchId: branchSelected?.value ?? "",
    };
    dispatch(onGetProductInventories(param));
  }

  function handleResetFilter() {
    setFilterDate(null);
    setProductInventoryList([]);
    setStatusActive([]);
    setSearchValue("");
    setGlobalFilter(undefined);
    setGlobalFilterValue("");

    dispatch(onGetProductInventories({ type: "inventory", branchId: branchSelected?.value ?? "" }));
  }

  document.title = "Kartu Gudang | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={productInventoryList} />
      <Container fluid>
        <BreadCrumb title="Persediaan" pageTitle="Kartu Gudang" loading={loading}>
          <div className="flex-shrink-0">
            <ExportDoc data={productInventoryDoc} />
          </div>
        </BreadCrumb>
        <Row>
          <Col lg={12}>
            <Card id="productInventoryList">
              <CardBody className="pt-0">
                <div>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <Row>
                        <Col sm={1}>
                          <div className="me-2 mb-2 col-12">
                            <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                              {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                <option key={pageSize} value={pageSize}>
                                  {pageSize}
                                </option>
                              ))}
                            </select>
                          </div>
                        </Col>
                        <Col sm={6}>
                          <div className="search-box me-2 mb-2 d-inline-block col-12">
                            <input
                              onChange={(e) => {
                                setSearchValue(e.target.value);
                                onChange(e.target.value);
                                gotoPage(0);
                              }}
                              id="search-bar-0"
                              type="text"
                              className="form-control search"
                              placeholder={`${count} Cari...`}
                              value={searchValue ?? ""}
                            />
                            <i className="bx bx-search-alt search-icon"></i>
                          </div>
                        </Col>
                        <Col sm={2}>
                          <div className="me-2 mb-2 col-12">
                            <Select
                              value={statusActive}
                              placeholder="Pilih Tipe"
                              onChange={(e) => {
                                handleProductInventoryStatus(e);
                                toggleType(e.value);
                              }}
                              options={statusActiveData}
                              name="choices-single-default"
                            ></Select>
                          </div>
                        </Col>

                        <Col sm={2}>
                          <div className="search-box me-2 mb-3 col-12">
                            <Flatpickr
                              className="form-control"
                              id="datepicker-publish-input"
                              placeholder="Pilih Tanggal"
                              options={{
                                mode: "range",
                                dateFormat: "Y/m/d",
                              }}
                              value={filterDate}
                              onChange={(selectedDates, dateStr) => {
                                setFilterDate(dateStr);
                              }}
                            />
                            <i className="bx bx-calendar-alt search-icon"></i>
                          </div>
                        </Col>
                        <Col sm={1}>
                          <div className="hstack gap-2">
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                              onClick={() => {
                                handleFilter();
                              }}
                            >
                              <i className="ri-search-line align-bottom fs-16"></i>
                            </button>
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                              onClick={() => {
                                handleResetFilter();
                              }}
                            >
                              <i className="mdi mdi-restore align-bottom fs-18"></i>
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th {...column.getSortByToggleProps()} className={"" + generateFilterable(column)} key={index}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          const detail = JSON.parse(row.values.Detail);
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                              {(detail || [])
                                .sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: "base" }))
                                .map((o, i) => {
                                  return (
                                    <tr key={i} className="bg-light">
                                      <td colSpan={3} className="p-2"></td>
                                      <td colSpan={6} className="text-start fs-11 p-2">
                                        {o.name}{" "}
                                        <span className="text-muted ms-2">
                                          ({parseFloat(o.quantity)} {o.inv_product?.product_uom?.name})
                                        </span>
                                      </td>
                                    </tr>
                                  );
                                })}
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex - 1);
                            previousPage();
                          }}
                          disabled={!canPreviousPage}
                        >
                          {" "}
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex + 1);
                            nextPage();
                          }}
                          disabled={!canNextPage}
                        >
                          {" "}
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModalDetail" isOpen={modalDetail} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggleDetail}>
                    {stock.transactionStatus === "IN" ? "PENERIMAAN BARANG" : "PENGELUARAN BARANG"}
                  </ModalHeader>
                  <ModalBody>
                    <Row id="printThis">
                      <Col lg={12}>
                        <CardHeader className="border-bottom-dashed p-4">
                          <Row className="g-3">
                            <Col lg={4} xs={4}>
                              <p className="text-muted mb-2 text-uppercase fw-semibold">Sender</p>
                              <h5 className="fs-14 mb-0">
                                <span id="invoice-no">{stock.sender}</span>
                              </h5>
                            </Col>
                            <Col lg={4} xs={4}>
                              <p className="text-muted mb-2 text-uppercase fw-semibold">Receiver</p>
                              <h5 className="fs-14 mb-0">
                                <span id="invoice-date">{stock.receiver}</span>
                              </h5>
                            </Col>
                          </Row>
                        </CardHeader>
                        <CardBody className="p-4">
                          <Row className="mb-3">
                            <Col lg={5}>
                              <div className="table-responsive">
                                <p className="text-muted mb-2 text-uppercase fw-semibold">Inventory</p>
                                <Table className="table-borderless text-center table-nowrap align-middle mb-0">
                                  <thead>
                                    <tr className="table-active">
                                      <th scope="col" style={{ width: "50px" }}>
                                        #
                                      </th>
                                      <th scope="col" className="text-start">
                                        Product
                                      </th>
                                      <th scope="col">Quantity</th>
                                      <th scope="col">Satuan</th>
                                    </tr>
                                  </thead>
                                  <tbody id="products-list">
                                    {((stock.details && stock.details.sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: "base" }))) || []).map((el, i) => {
                                      return (
                                        <tr key={el.id} className="product">
                                          <th scope="row" className="product-id">
                                            {i + 1}
                                          </th>
                                          <td className="text-start overflow-hidden" style={{ maxWidth: "100px", textOverflow: "ellipsis" }}>
                                            {el.name}
                                          </td>
                                          <td>{el.quantity ? parseFloat(el.quantity) : 0}</td>
                                          <td>{el?.inv_product?.product_uom?.name}</td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </Table>
                              </div>
                            </Col>
                            <Col lg={7}>
                              <div className="table-responsive">
                                <p className="text-muted mb-2 text-uppercase fw-semibold">{stock.transactionType === "Transfer" ? "Transfer" : stock.transactionType === "Purchase" ? "Purchase" : "Sales"}</p>
                                <Table className="table-borderless text-center table-nowrap align-middle mb-0">
                                  <thead>
                                    <tr className="table-active">
                                      <th scope="col" style={{ width: "50px" }}>
                                        #
                                      </th>
                                      <th scope="col" className="text-start">
                                        Product
                                      </th>
                                      <th scope="col">Quantity</th>
                                      <th scope="col">Accepted</th>
                                      <th scope="col">Rejected</th>
                                    </tr>
                                  </thead>
                                  <tbody id="products-list">
                                    {stock.transactionType === "Purchase"
                                      ? ((stock.purchases && stock.purchases.sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: "base" }))) || []).map((el, i) => {
                                        return (
                                          <tr key={el.id} className="product">
                                            <th scope="row" className="product-id">
                                              {i + 1}
                                            </th>
                                            <td className="text-start overflow-hidden" style={{ maxWidth: "100px", textOverflow: "ellipsis" }}>
                                              {el.name}
                                            </td>
                                            <td>{el.quantity ? parseFloat(el.quantity) : 0}</td>
                                            <td>{el.accepted ? parseFloat(el.accepted) : 0}</td>
                                            <td>{el.rejected ? parseFloat(el.rejected) : 0}</td>
                                          </tr>
                                        );
                                      })
                                      : ((stock.transfers && stock.transfers.sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: "base" }))) || []).map((el, i) => {
                                        return (
                                          <tr key={el.id} className="product">
                                            <th scope="row" className="product-id">
                                              {i + 1}
                                            </th>
                                            <td className="text-start overflow-hidden" style={{ maxWidth: "100px", textOverflow: "ellipsis" }}>
                                              {el.name}
                                            </td>
                                            <td>{el.quantity ? parseFloat(el.quantity) : 0}</td>
                                            <td>{el.accepted ? parseFloat(el.accepted) : 0}</td>
                                            <td>{el.rejected ? parseFloat(el.rejected) : 0}</td>
                                          </tr>
                                        );
                                      })}
                                  </tbody>
                                </Table>
                              </div>
                            </Col>
                          </Row>
                          {/* <div className="table-responsive">
                            <Table className="table-borderless text-center table-nowrap align-middle mb-0">
                              <thead>
                                <tr className="table-active">
                                  <th scope="col" style={{ width: "50px" }}>#</th>
                                  <th scope="col" className="text-start">Product</th>
                                  <th scope="col">Need adjustment</th>
                                </tr>
                              </thead>
                              <tbody id="products-list">
                                <tr className="product">
                                  <th scope="row" className="product-id">-</th>
                                  <td className="text-center">-</td>
                                  <td className="text-center">-</td>
                                </tr>
                              </tbody>
                            </Table>
                          </div> */}
                        </CardBody>
                        <CardBody className="p-4">
                          <Row className="g-3">
                            {(stock.inv_file || []).map((f, i) => {
                              if (f.isDeleted) {
                                return null;
                              } else {
                                return (
                                  <Col lg={3} xs={3} key={i}>
                                    {f.mimetype === "image/jpg" || f.mimetype === "image/png" || f.mimetype === "image/jpeg" ? (
                                      <ModalImage showRotate={true} small={f.filename === "" ? "" : `${api.MEDIA_URL}/media/${f.filename}-w-50`} large={f.filename === "" ? "" : `${api.MEDIA_URL}/media/${f.filename}`} alt={f.originalname} className="img-thumbnail avatar-md img-thumbnail user-profile-image" />
                                    ) : (
                                      <Link to={`${api.MEDIA_URL}/media/${f.filename}`} target="_blank" className={"img-thumbnail avatar-md img-thumbnail user-profile-image"}>
                                        <i className="ri-file-pdf-line fs-3 text-danger"></i>
                                      </Link>
                                    )}
                                  </Col>
                                );
                              }
                            })}
                          </Row>
                        </CardBody>
                      </Col>
                    </Row>
                  </ModalBody>
                  {/* <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button type="button" className="btn btn-light" onClick={() => { setModalDetail(false); }}> Close </button>
                      <button type="submit" className="btn btn-info" onClick={() => {
                         printInvoice(document.getElementById("printThis"))
                      }}>Print Document</button>
                      {info.statusId === 2 && (<button type="submit" className="btn btn-success" onClick={() => {
                        info.statusProductInventoryId = 3;
                        setProductInventory(info);
                        toggleApprove();
                      }}>Confirmed ProductInventory</button>)}
                      {info.statusId === 3 && (<button type="submit" className="btn btn-warning" onClick={() => {
                        info.statusProductInventoryId = 4;
                        setProductInventory(info);
                        toggleApprove();
                      }}>Processed ProductInventory</button>)}
                    </div>
                  </div> */}
                </Modal>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default StockCard;